import isEqual from 'lodash-es/isEqual';
import React from 'react';
import { FilterDropdown } from '@components/common/FilterDropdown';
import { Checkbox } from '@fourthwall/components';
import { useFormik } from '@fourthwall/utils/dist/formik';
import * as S from './PromotionCodesFilter.styled';
import { useFilterPromotionCodes } from './hooks/useFilterPromotionCodes';
export const PromotionCodesFilter = () => {
    const { filtersParams, setFiltersParams, resetFiltersParams, hasFilterParams } = useFilterPromotionCodes();
    const handleSubmit = (values) => {
        setFiltersParams({
            creationReason: values.showGiftRedemptions ? 'MANUAL,FROM_GIFT' : undefined,
        });
    };
    const formik = useFormik({
        initialValues: {
            showGiftRedemptions: isEqual(filtersParams.creationReason, 'MANUAL,FROM_GIFT'),
        },
        onSubmit: handleSubmit,
    });
    const handleReset = () => {
        formik.resetForm();
        resetFiltersParams();
    };
    return (React.createElement(FilterDropdown, { content: React.createElement(S.Form, null,
            React.createElement(S.FormRow, null,
                React.createElement(Checkbox, { label: "Show gift redemptions", ...formik.getFieldProps('showGiftRedemptions') }))), activityIndicator: hasFilterParams, onSubmit: formik.handleSubmit, onReset: handleReset }));
};
